import React from "react";

export const DataStoryRegionNotFoundPage = () => {
  return <p className="lead">Not Found</p>;
};
